export class CadastrarContatoModel {
    constructor(
        public nome: string = '',
        public telefone: string = '',
        public email: string = '',
        public nomeEmpresa: string = '',
        public cpfcnpj: string = '',
        public responsavelId: string = '',
        public dataVisita: Date = new Date(),
        public observacao: string = '',
        public negociacao: string = ''
    ) { }
}